// ImageProfile.js

import React, { useEffect, useRef } from "react";
import hoverEffect from "hover-effect";
import distortionimage from "./assets/distortionimage.jpg";
import broselookgood from "./assets/broselookgood.jpg";

const Personalimage = () => {
  const imageRef = useRef(null);

  useEffect(() => {
    // Create the hover effect when the component mounts
    const myAnimation = new hoverEffect({
      parent: imageRef.current,
      intensity: 0.3,
      imagesRatio: 1620 / 1080,
      image1: broselookgood,
      image2: broselookgood,
      displacementImage: distortionimage,
    });

    // Cleanup function when the component unmounts
    return () => {
      myAnimation.next(); // Transition in
      myAnimation.previous(); // Transition out
    };
  }, []); // Run only once when the component mounts
  return <div className="images" ref={imageRef}></div>;
};

export default Personalimage;
